import React, {useContext} from "react";
import { IoMdClose } from 'react-icons/io';
import { IconContext } from "react-icons";
import { NavToggleContext } from "../components/navToggleContext";
import useTranslations from "../utils/useTranslations";
import SimplexNotificationIcon from '../images/simplex/simplex-notification-icon.svg';
import Button from "../components/button";

const SimplexNotification = (props) => {
	const toggleNav = useContext(NavToggleContext);
	const {indexText} = props;
	const t = useTranslations(indexText);

	const handleBttClick = (e) => {
		toggleNav('BTT');
		props.closeSimplexNotification(e);
	}

	return(
		<div id="simplex-notification" onClick={handleBttClick} className="simplex-notification-container pointer">
			<IconContext.Provider value={{ size:"24px", color:"white" }}>
				<IoMdClose onClick={props.closeSimplexNotification} className="simplex-notif-close-btn pointer"/>
			</IconContext.Provider>
			<img src={SimplexNotificationIcon} className="img-fluid mb-4" alt="Simplex Notification Icon"/>
			<p className="simplex-notification-header mb-3">
				{t("Buy BTT in BitTorrent is live now")}
			</p>
			<p className="simplex-notification-text mb-4">
				{t("We have added a Buy BTT for FIAT feature to BitTorrent. You can purchase BTT with FIAT using a wide range of payment methods directly.")}
			</p>
			<Button id="simplex-notification-get-btt" className="simplex-notification-btn px-4">{t(`Get BTT`)}</Button>
		</div>
	)
}

export default SimplexNotification;
